import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import { route } from "./../../../router/route";
import Checkbox from "./../../../component/atoms/input/checkbox";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Modal from "../../../component/templates/Modal";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useNavigate } from "react-router-dom";
import scrollToTop from "../../../util/scrollToTop";
import SelectBox from "../../../component/organisms/selectBox";
import DividedBtn from "../../../component/atoms/button/dividedBtn";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import CategoryApi from "../../../api/category.api";
import { useRecoilState } from "recoil";
import {
  initialProductManagementState,
  productManagementState,
  productIsUploadState,
} from "../../../store/productState";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ProductApi from "../../../api/product.api";
import moment from "moment";

// TODO:
// - 오픈 예정 숨겨놓음 추후에 오픈 알림 기능 추가 시 주석 해제

const ShoppingProductCreateBasic = () => {
  const navigate = useNavigate();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getMainCategoryList();
    getStorageList();

    if (productManagementValue.merchMainCategoryId === 0) {
      setProductManagementValue(initialProductManagementState);
      setProductIsUpload(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 새로고침 이벤트 관련 ---------- //
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    // 새로고침 및 페이지 떠남 이벤트 감지
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 업로드 상태 관련 ---------- //
  const [productIsUpload, setProductIsUpload] =
    useRecoilState(productIsUploadState);

  // ---------- 상품 추가 입력값 관련 ---------- //
  const [productManagementValue, setProductManagementValue] = useRecoilState(
    productManagementState
  );

  // ---------- 전체 영역 팝업 상태 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState({
    categorySetting: false, // 하위 카테고리 관리
    temporary: false, // 임시저장
  });

  // ---------- 메인 카테고리 관련 ---------- //
  // 메인 카테고리 관련 상태
  const [mainCategoryList, setMainCategoryList] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState({
    id: 0,
    title: "",
  });
  const [selectedPopupMainCategory, setSelectedPopupMainCategory] = useState({
    id: 0,
    title: "",
  });

  // 메인 카테고리 선택 시 상태 변경
  useEffect(() => {
    if (selectedMainCategory.id !== 0) {
      setProductManagementValue((prev) => ({
        ...prev,
        merchContentType:
          selectedMainCategory.id === 2
            ? "LECTURE"
            : selectedMainCategory.id === 4 || selectedMainCategory.id === 5
            ? "CLASS"
            : "BOOK",
        merchMainCategoryId: selectedMainCategory.id,
      }));
      setSelectedSubCategory({
        id: 0,
        title: "",
      });
    } else {
      setProductManagementValue((prev) => ({
        ...prev,
        merchContentType: "BOOK",
        merchMainCategoryId: 0,
      }));
      setSelectedSubCategory({
        id: 0,
        title: "",
      });
    }
  }, [selectedMainCategory]); // eslint-disable-line react-hooks/exhaustive-deps

  const [mainCategoryBoxOpen, setMainCategoryBoxOpen] = useState(false);

  // 메인 카테고리 리스트 가져오기
  const getMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };

      const response = (await CategoryApi.getListMain(data)).data.data.content;

      setMainCategoryList(response);

      if (productManagementValue.merchMainCategoryId !== 0) {
        const selectedMainCategory = response.find(
          (category) =>
            category.id === productManagementValue.merchMainCategoryId
        );

        if (
          selectedMainCategory !== undefined &&
          JSON.stringify(selectedMainCategory) !== "[]"
        ) {
          setSelectedMainCategory(selectedMainCategory);
          getSelectedSubCategoryData(); // 선택된 하위 카테고리 데이터 가져오기
        }
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 하위 카테고리 관련 ---------- //
  // 하위 카테고리 관련 상태
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subCategoryBoxOpen, setSubCategoryBoxOpen] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    id: 0,
    title: "",
  });
  const [selectedPopupSubCategory, setSelectedPopupSubCategory] = useState({
    id: 0,
    title: "",
  });

  // 하위 카테고리 선택 시 상태 변경
  useEffect(() => {
    if (selectedSubCategory.id !== 0) {
      setProductManagementValue((prev) => ({
        ...prev,
        merchSubCategoryId: selectedSubCategory.id,
      }));
    } else {
      setProductManagementValue((prev) => ({
        ...prev,
        merchSubCategoryId: 0,
      }));
    }
  }, [selectedSubCategory]); // eslint-disable-line react-hooks/exhaustive-deps

  // 하위 카테고리 관리 팝업 상태 변경에 따른 상태 변경
  useEffect(() => {
    setSelectedPopupMainCategory({
      id: 0,
      title: "",
    });
    setSelectedPopupSubCategory({
      id: 0,
      title: "",
    });
    setSubCategoryList([]);
  }, [popupOpen.categorySetting]); // eslint-disable-line react-hooks/exhaustive-deps

  // 하위 카테고리 관리 팝업 내 상위 카테고리 변경에 따른 선택된 하위 카테고리 초기화
  useEffect(() => {
    setSelectedPopupSubCategory({
      id: 0,
      title: "",
    });
  }, [selectedPopupMainCategory]);

  // 하위 카테고리 드래그 앤 드롭
  const handleDragAndDrop = async (result) => {
    const { destination, source } = result;

    // 드래그가 취소된 경우
    if (!destination) return;

    // 기존 배열을 복사
    const updatedList = Array.from(subCategoryList);

    // 드래그된 요소를 배열에서 제거하고 새로운 위치에 삽입
    const [reorderedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, reorderedItem);

    setSubCategoryList(updatedList);

    // 상태 업데이트
    const data = {
      merchSubCategoryList: updatedList,
    };

    await CategoryApi.updateSub(data);

    setSelectedPopupSubCategory({
      id: 0,
      title: "",
    });

    getSubCategoryList(selectedPopupMainCategory.id);
  };

  // 하위 카테고리 리스트 가져오기
  const getSubCategoryList = async (mainCategoryId) => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
        merchMainCategoryId: mainCategoryId
          ? mainCategoryId
          : selectedMainCategory.id,
      };

      const response = await CategoryApi.getListSub(data);
      setSubCategoryList(response.data.data.content);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 선택된 하위 카테고리 데이터 가져오기
  const getSelectedSubCategoryData = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
      };

      const response = (await CategoryApi.getListSub(data)).data.data.content;

      if (productManagementValue.merchSubCategoryId !== 0) {
        const selectedSubCategory = response.find(
          (category) =>
            category.id === productManagementValue.merchSubCategoryId
        );

        if (
          selectedSubCategory !== undefined &&
          JSON.stringify(selectedSubCategory) !== "[]"
        ) {
          setSelectedSubCategory(selectedSubCategory);
        }
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // 하위 카테고리 추가하기
  const createSubCategory = async () => {
    try {
      if (selectedPopupSubCategory.title === "") {
        toast("카테고리명을 입력해주세요.");
        return;
      } else {
        const data = {
          merchMainCategoryId: selectedPopupMainCategory.id,
          title: selectedPopupSubCategory.title,
        };
        await CategoryApi.createSub(data);
        setSelectedPopupSubCategory({
          id: 0,
          title: "",
        });
        getSubCategoryList(selectedPopupMainCategory.id);
        toast(toastMsg.create);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // 하위 카테고리 수정하기
  const updateSubCategory = async () => {
    try {
      const updatedSubCategoryList = subCategoryList.map((category) => {
        if (category.id === selectedPopupSubCategory.id) {
          return {
            id: selectedPopupSubCategory.id,
            title: selectedPopupSubCategory.title,
            activation: selectedPopupSubCategory.activation,
          };
        }

        return category;
      });

      const data = {
        merchSubCategoryList: updatedSubCategoryList,
      };

      await CategoryApi.updateSub(data);

      setSelectedPopupSubCategory({
        id: 0,
        title: "",
      });
      toast(toastMsg.update);
      getSubCategoryList(selectedPopupMainCategory.id);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 하위 카테고리 삭제하기
  const [subCategoryDeleteId, setSubCategoryDeleteId] = useState(0);
  const [subCategoryDeleteModalOpen, setSubCategoryDeleteModalOpen] =
    useState(false);

  const subCategoryDeleteHandler = async () => {
    try {
      await CategoryApi.deleteSub(subCategoryDeleteId);
      toast(toastMsg.delete);
      setSubCategoryDeleteModalOpen(false);
      setSelectedPopupSubCategory({
        id: 0,
        title: "",
      });
      getSubCategoryList(selectedPopupMainCategory.id);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 임시저장 관련 ---------- //
  // 임시저장 상태 관련
  const [storageList, setStorageList] = useState([]);
  const [storageListCount, setStorageListCount] = useState(0);
  const [storageData, setStorageData] = useState({});

  // 임시저장 데이터 리스트 가져오기
  const getStorageList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        saveStatus: "N",
      };
      const response = await ProductApi.getListProduct(data);
      setStorageList(response.data.data.content);
      setStorageListCount(response.data.data.totalCount);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 임시저장 데이터 삭제 관련
  const [deleteStorageItemModalOpen, setDeleteStorageItemModalOpen] =
    useState(false);
  const [deleteStorageItemId, setDeleteStorageItemId] = useState(0);

  const handleDeleteStorageItem = async () => {
    try {
      await ProductApi.deleteProduct(deleteStorageItemId);
      toast(toastMsg.delete);
      setDeleteStorageItemModalOpen(false);
      getStorageList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 임시저장 데이터 불러오기
  const handleLoadStorageItem = async (id) => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;
      setStorageData(response);

      setProductManagementValue({
        ...response,
        merchMainCategoryId: response?.merchMainCategory?.id || 0,
        merchSubCategoryId: response?.merchSubCategory?.id || 0,
        title: response.title || "",
        writer: response.writer || "",
        price: response.price || 0,
        isPreviewEnabled: response.isPreviewEnabled || false,
        isFreeTrial: response.isFreeTrial || false,
        isComingSoon: response.isComingSoon || false,
        isMembershipOnly: response.isMembershipOnly || false,
        isNonSale: response.isNonSale || false,
        intro: response.intro || "",
        content: response.content || "",
        thumbnailOriginFileName: response.thumbnailOriginFileName || "",
        thumbnailServerFileName: response.thumbnailServerFileName || "",
        bannerOriginFileName: response.bannerOriginFileName || "",
        bannerServerFileName: response.bannerServerFileName || "",
        relatedMerchUse: response.relatedMerchUse || false,
        openAlarmUse: response.openAlarmUse || false,
        merchType: response.merchType || "SHOP",
        merchContentType: response.merchContentType || "BOOK",
      });

      setProductIsUpload(false);
      setPopupOpen((prevPopup) => ({
        ...prevPopup,
        temporary: false,
      }));
      setSelectedMainCategory({
        id: response?.merchMainCategory?.id || 0,
        title: response?.merchMainCategory?.title || "",
      });

      // 딜레이 걸지 않으면 상위 카테고리 변경에 따른 하위 카테고리 초기화 코드 로직과 충돌 발생
      setTimeout(() => {
        setSelectedSubCategory({
          id: response?.merchSubCategory?.id || 0,
          title: response?.merchSubCategory?.title || "",
        });
      }, 500);

      navigate(route.shopping_product_create_basic);
      toast("임시저장 데이터를 불러왔습니다.");
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 다음 단계로 이동 ---------- //
  const handleNextStep = async () => {
    try {
      if (productManagementValue.title === "") {
        toast("상품 제목을 입력해주세요.");
        return;
      } else if (selectedMainCategory?.id === 0) {
        toast("상위 카테고리를 선택해주세요.");
        return;
      } else if (selectedSubCategory?.id === 0) {
        toast("하위 카테고리를 선택해주세요.");
        return;
      } else if (productManagementValue.writer === "") {
        toast("저자/크리에이터를 입력해주세요.");
        return;
      } else if (isNaN(productManagementValue.price)) {
        toast("숫자만 입력해주세요.");
        return;
      }

      // 임시저장된 데이터를 불러온 뒤 수정 시 수정 여부 확인 후 수정 API 호출
      if (!productIsUpload) {
        const data = {
          title: productManagementValue.title,
          writer: productManagementValue.writer,
          price: productManagementValue.price,
          isPreviewEnabled: productManagementValue.isPreviewEnabled,
          isFreeTrial: productManagementValue.isFreeTrial,
          isComingSoon: productManagementValue.isComingSoon,
          isMembershipOnly: productManagementValue.isMembershipOnly,
          isNonSale: productManagementValue.isNonSale,
          intro: productManagementValue.intro,
          content: productManagementValue.content,
          thumbnailOriginFileName:
            productManagementValue.thumbnailOriginFileName,
          thumbnailServerFileName:
            productManagementValue.thumbnailServerFileName,
          bannerOriginFileName: productManagementValue.bannerOriginFileName,
          bannerServerFileName: productManagementValue.bannerServerFileName,
          relatedMerchUse: productManagementValue.relatedMerchUse,
          openAlarmUse: productManagementValue.openAlarmUse,
          merchType: "SHOP",
          merchMainCategoryId: selectedMainCategory.id,
          merchSubCategoryId: selectedSubCategory.id,
        };

        // 무료/체험판 or 멤버십 전용 상품인 경우 가격 0원으로 설정
        if (
          productManagementValue.isFreeTrial ||
          productManagementValue.isMembershipOnly
        ) {
          data.price = 0;
        }

        if (selectedMainCategory.id === 2) {
          data.merchContentType = "LECTURE";
        } else if (
          selectedMainCategory.id === 4 ||
          selectedMainCategory.id === 5
        ) {
          data.merchContentType = "CLASS";
        } else {
          data.merchContentType = "BOOK";
        }
        await ProductApi.updateProduct(productManagementValue.id, data);
      }

      // handleLoadStorageItem(productManagementValue.id);
      navigate(route.shopping_product_create_detail);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 추가">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  style={{
                    cursor: "default",
                  }}
                  selected={item === pageTitleList[0]}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[0]}</TableTitle>
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* 상품 제목 영역 */}
            <BasicContentSettingInputWrapper
              style={{
                padding: "21px 0px",
              }}
            >
              <BasicContentSettingInputTitle>
                상품 제목
              </BasicContentSettingInputTitle>
              <MainInput
                type={"text"}
                placeholder={"상품 제목을 입력해 주세요."}
                style={{ width: "744px" }}
                value={productManagementValue.title}
                onChange={(e) => {
                  setProductManagementValue({
                    ...productManagementValue,
                    title: e.target.value,
                  });
                }}
              />
            </BasicContentSettingInputWrapper>

            {/* 카테고리 영역 */}
            <BasicContentSettingInputWrapper
              style={{
                padding: "24px 0px",
              }}
            >
              <BasicContentSettingInputTitle>
                카테고리
              </BasicContentSettingInputTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <SelectBox
                  placeholder="상위 카테고리를 선택해주세요"
                  selectedValue={selectedMainCategory.title || ""}
                  isOpen={mainCategoryBoxOpen}
                  wrapperHandler={() => {
                    if (subCategoryBoxOpen) {
                      setSubCategoryBoxOpen(false);
                    }
                    setMainCategoryBoxOpen(!mainCategoryBoxOpen);
                  }}
                  itemList={mainCategoryList}
                  selectedValueSetterFunc={setSelectedMainCategory}
                  itemHandler={getSubCategoryList}
                />
                <SelectBox
                  placeholder="하위 카테고리를 선택해주세요"
                  selectedValue={selectedSubCategory.title || ""}
                  isOpen={subCategoryBoxOpen}
                  wrapperHandler={() => {
                    if (mainCategoryBoxOpen) {
                      setMainCategoryBoxOpen(false);
                    } else {
                      setSubCategoryBoxOpen(!subCategoryBoxOpen);
                      getSubCategoryList();
                    }
                  }}
                  itemList={subCategoryList}
                  selectedValueSetterFunc={setSelectedSubCategory}
                />
                <GrayBtn
                  onClick={() => {
                    setPopupOpen((prevPopup) => ({
                      ...prevPopup,
                      categorySetting: true,
                    }));
                  }}
                >
                  하위 카테고리 관리
                </GrayBtn>
                {/* <CheckboxWrapper onClick={() => {}}>
                      <Checkbox checked={false} onChange={() => {}} />
                      <CheckboxText>하위 카테고리 사용안함</CheckboxText>
                    </CheckboxWrapper> */}
              </div>
            </BasicContentSettingInputWrapper>

            {/* 저자/크리에이터 영역 */}
            <BasicContentSettingInputWrapper
              style={{
                padding: "21px 0px",
              }}
            >
              <BasicContentSettingInputTitle>
                저자/크리에이터
              </BasicContentSettingInputTitle>
              <MainInput
                type={"text"}
                placeholder={"저자/크리에이터을 입력해 주세요."}
                style={{ width: "338px" }}
                value={productManagementValue.writer}
                onChange={(e) => {
                  setProductManagementValue({
                    ...productManagementValue,
                    writer: e.target.value,
                  });
                }}
              />
            </BasicContentSettingInputWrapper>

            {/* 상품 옵션 영역 */}
            <BasicContentSettingInputWrapper
              style={{
                padding: "33.5px 0px",
              }}
            >
              <BasicContentSettingInputTitle>
                상품 옵션
              </BasicContentSettingInputTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 24,
                }}
              >
                {/* {selectedMainCategory.id !== 0 &&
                  selectedMainCategory.id !== 3 &&
                  selectedMainCategory.id !== 4 &&
                  selectedMainCategory.id !== 5 && (
                    <CheckboxWrapper>
                      <Checkbox
                        checked={productManagementValue.isPreviewEnabled}
                        onChange={(e) => {
                          setProductManagementValue({
                            ...productManagementValue,
                            isPreviewEnabled: e.target.checked,
                          });
                        }}
                      />
                      <CheckboxText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "#aaa",
                        }}
                      >
                        미리보기 기능 사용
                      </CheckboxText>
                    </CheckboxWrapper>
                  )} */}
                <CheckboxWrapper>
                  <Checkbox
                    checked={productManagementValue.isFreeTrial}
                    onChange={(e) => {
                      setProductManagementValue({
                        ...productManagementValue,
                        price: e.target.checked
                          ? 0
                          : productManagementValue.price,
                        isFreeTrial: !productManagementValue.isFreeTrial,
                      });
                    }}
                  />
                  <CheckboxText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    무료/체험판
                  </CheckboxText>
                </CheckboxWrapper>
                {/* <CheckboxWrapper>
                  <Checkbox
                    checked={productManagementValue.isComingSoon}
                    onChange={() => {
                      setProductManagementValue({
                        ...productManagementValue,
                        isComingSoon: !productManagementValue.isComingSoon,
                      });
                    }}
                  />
                  <CheckboxText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    오픈 예정
                  </CheckboxText>
                </CheckboxWrapper> */}
                <CheckboxWrapper>
                  <Checkbox
                    checked={productManagementValue.isNonSale}
                    onChange={() => {
                      setProductManagementValue({
                        ...productManagementValue,
                        isNonSale: !productManagementValue.isNonSale,
                      });
                    }}
                  />
                  <CheckboxText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    비매품
                  </CheckboxText>
                </CheckboxWrapper>
                <CheckboxWrapper>
                  <Checkbox
                    checked={productManagementValue.isMembershipOnly}
                    onChange={(e) => {
                      setProductManagementValue({
                        ...productManagementValue,
                        price: e.target.checked
                          ? 0
                          : productManagementValue.price,
                        isMembershipOnly:
                          !productManagementValue.isMembershipOnly,
                      });
                    }}
                  />
                  <CheckboxText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    수강권 구매자 전용 상품
                  </CheckboxText>
                </CheckboxWrapper>
              </div>
            </BasicContentSettingInputWrapper>

            {/* 상품 가격 영역 */}
            <BasicContentSettingInputWrapper
              style={{
                padding: "21px 0px",
              }}
            >
              <BasicContentSettingInputTitle>
                상품 가격
              </BasicContentSettingInputTitle>
              <MainInput
                type={"text"}
                placeholder={"상품 가격을 입력해 주세요."}
                style={{ width: "338px" }}
                value={productManagementValue.price}
                disabled={
                  productManagementValue.isFreeTrial ||
                  productManagementValue.isMembershipOnly
                }
                onChange={(e) => {
                  if (isNaN(e.target.value)) {
                    return;
                  } else {
                    setProductManagementValue({
                      ...productManagementValue,
                      price: Number(e.target.value),
                    });
                  }
                }}
              />
            </BasicContentSettingInputWrapper>

            <div
              style={{
                width: "100%",
                height: 79,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: 12,
              }}
            >
              <DividedBtn
                onClick={() => {
                  setPopupOpen((prevPopup) => ({
                    ...prevPopup,
                    temporary: true,
                  }));
                }}
                text1="임시저장"
                text2={storageListCount}
                textHandler={() => {
                  setPopupOpen((prevPopup) => ({
                    ...prevPopup,
                    temporary: true,
                  }));
                }}
              />
              <BasicBtn onClick={handleNextStep}>다음으로</BasicBtn>
            </div>
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 하위 카테고리 관리 팝업 */}
      {popupOpen.categorySetting && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              categorySetting: false,
            }));
          }}
        >
          <Popup
            headerTitle="하위 카테고리 관리"
            footerBtnText="저장하기"
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                categorySetting: false,
              }));
            }}
            footerBtnHandler={() => {
              if (
                selectedPopupSubCategory.id !== 0 &&
                selectedPopupSubCategory.title === ""
              ) {
                toast("하위 카테고리명을 입력해주세요.");
                return;
              } else if (
                selectedPopupSubCategory.id !== 0 &&
                selectedPopupSubCategory.title !== ""
              ) {
                updateSubCategory();
              } else return;
            }}
          >
            <div
              style={{
                width: "fit-content",
                height: "fit-content",
                margin: "16px 30px",
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "200px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {mainCategoryList.map((item, index) => {
                  return (
                    <SubSideBarItem
                      key={index}
                      selected={selectedPopupMainCategory.id === item.id}
                      onClick={() => {
                        setSelectedPopupMainCategory({
                          id: item.id,
                          title: item.title,
                        });
                        getSubCategoryList(item.id);
                      }}
                    >
                      {item.title}
                    </SubSideBarItem>
                  );
                })}
              </div>
              <span
                style={{
                  width: "1px",
                  height: "399px",
                  marginLeft: "14px",
                  marginRight: "20px",
                  backgroundColor: "rgba(255, 255, 255, 0.12)",
                }}
              />
              {selectedPopupMainCategory.id !== 0 && (
                <div
                  style={{
                    width: "338px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "100%",

                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "3px",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      하위 카테고리 추가
                    </PretendardText>
                    <MainInput
                      type={"text"}
                      placeholder={"하위 카테고리명을 입력해 주세요."}
                      style={{ width: "338px" }}
                      value={selectedPopupSubCategory.title}
                      onChange={(e) => {
                        setSelectedPopupSubCategory({
                          id: selectedPopupSubCategory.id,
                          title: e.target.value,
                        });
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                      }}
                    >
                      <button
                        style={{
                          width: "fit-content",
                          height: "fit-content",
                          padding: "10px 20px",
                          backgroundColor: "transparent",
                          borderRadius: "23px",
                          border: "1px solid rgba(255, 255, 255, 0.12)",
                          marginTop: 7,
                        }}
                        onClick={() => {
                          createSubCategory();
                        }}
                      >
                        <PretendardText
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            lineHeight: "22px",
                            letterSpacing: "-0.3%",
                            color: "#aaa",
                          }}
                        >
                          추가
                        </PretendardText>
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "10px",
                      marginTop: "20px",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        lineHeight: "22px",
                        color: "#aaa",
                      }}
                    >
                      하위 카테고리 목록
                    </PretendardText>
                    <div
                      className="custom-scrollbar"
                      style={{
                        width: "100%",
                        minHeight: "88px",
                        maxHeight: "215px",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 5,
                      }}
                    >
                      <DragDropContext onDragEnd={handleDragAndDrop}>
                        <Droppable droppableId="mainCategories">
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {subCategoryList.map((item, index) => {
                                return (
                                  <Draggable
                                    key={item.id}
                                    draggableId={String(item.id)}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div
                                          key={index}
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            paddingRight: "5px",
                                            backgroundColor:
                                              selectedPopupSubCategory.id ===
                                              item.id
                                                ? "#313233"
                                                : "transparent",
                                          }}
                                        >
                                          <SubSideBarItem
                                            style={{
                                              width: "200px",
                                            }}
                                            selected={
                                              selectedPopupSubCategory.id ===
                                              item.id
                                            }
                                            move={true}
                                            onClick={() => {
                                              setSelectedPopupSubCategory({
                                                id: item.id,
                                                title: item.title,
                                              });
                                            }}
                                          >
                                            {item.title}
                                          </SubSideBarItem>
                                          <RedBtn
                                            onClick={() => {
                                              setSubCategoryDeleteId(item.id);
                                              setSubCategoryDeleteModalOpen(
                                                true
                                              );
                                            }}
                                          >
                                            삭제
                                          </RedBtn>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <ul
              style={{
                position: "absolute",
                left: 30,
                bottom: 50,
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "#aaa",
                marginRight: 0,
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                마우스 드래그로 하위 카테고리 순서를 조정해보세요
              </li>
            </ul>
          </Popup>
        </PopupOverLay>
      )}

      {/* 임시저장 팝업 */}
      {popupOpen.temporary && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              temporary: false,
            }));
          }}
        >
          <Popup
            headerTitle="임시저장 글"
            noFooter={true}
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                temporary: false,
              }));
            }}
          >
            <div
              className="custom-scrollbar"
              style={{
                width: "100%",
                maxHeight: 284,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
                padding: "0px 30px",
              }}
            >
              {storageList.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: 71,
                      padding: "15px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom:
                        "0.5px solid var(--outline1, rgba(255, 255, 255, 0.12))",
                    }}
                  >
                    <div
                      style={{
                        width: 515,
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleLoadStorageItem(item.id);
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {moment(item.updatedAt).format("YYYY-MM-DD HH:mm")}
                      </PretendardText>
                    </div>
                    <RedBtn
                      onClick={() => {
                        setDeleteStorageItemId(item.id);
                        setDeleteStorageItemModalOpen(true);
                      }}
                    >
                      삭제
                    </RedBtn>
                  </div>
                );
              })}
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 하위 카테고리 삭제하기 모달 */}
      {subCategoryDeleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setSubCategoryDeleteModalOpen}
          onClick={subCategoryDeleteHandler}
        />
      )}

      {/* 임시저장 삭제하기 모달 */}
      {deleteStorageItemModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteStorageItemModalOpen}
          onClick={handleDeleteStorageItem}
        />
      )}
    </>
  );
};

export default ShoppingProductCreateBasic;

const BasicContentSettingInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const BasicContentSettingInputTitle = styled(PretendardText).attrs(
  (props) => {}
)`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
